import { render } from "./car.vue?vue&type=template&id=4384c624&scoped=true&ts=true"
import script from "./car.vue?vue&type=script&lang=tsx"
export * from "./car.vue?vue&type=script&lang=tsx"

import "./car.vue?vue&type=style&index=0&id=4384c624&lang=less&scoped=true"

import exportComponent from "E:\\qihe\\ly-visitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4384c624"]])

export default __exports__